// components/catalog/OrganizationProductCard.jsx
import { useState } from 'react';

export default function OrganizationProductCard({ product, onSelect, disabled, maxQuantity }) {
  const [quantity, setQuantity] = useState(1);

  const handleQuantityChange = (e) => {
    const value = Math.min(Math.max(1, parseInt(e.target.value) || 1), product.max_quantity);
    setQuantity(value);
  };

  const handleSelect = () => {
    onSelect(product, quantity);
  };

  const totalPrice = product.price * quantity;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 flex flex-col h-full">
      <img 
        src={product.image_url || '/api/placeholder/300/200'} 
        alt={product.name}
        className="w-full h-48 object-cover"
      />
      <div className="p-4 flex flex-col flex-grow">
        <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100 mb-2 line-clamp-2">
          {product.name}
        </h3>
        <p className="text-gray-600 dark:text-gray-300 text-sm mb-3 line-clamp-3 flex-grow">
          {product.description}
        </p>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Quantity (Max: {product.max_quantity})
          </label>
          <input
            type="number"
            min="1"
            max={product.max_quantity}
            value={quantity}
            onChange={handleQuantityChange}
            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white"
            disabled={disabled}
          />
        </div>

        {/* Price Information - Stacked vertically */}
        <div className="space-y-2 mb-4">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Unit Price:</span>
            <span className="text-lg font-bold text-orange-600 dark:text-orange-400">
              ₦{product.price.toLocaleString()}
            </span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Price:</span>
            <span className="text-lg font-bold text-gray-800 dark:text-gray-200">
              ₦{totalPrice.toLocaleString()}
            </span>
          </div>
        </div>

        <button
          onClick={handleSelect}
          disabled={disabled}
          className="w-full bg-orange-500 text-white py-2 px-4 rounded-md hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 mt-auto"
        >
          {disabled ? 'Request Submitted' : `Request ${quantity} Item${quantity !== 1 ? 's' : ''}`}
        </button>
      </div>
    </div>
  );
}